import  styled  from "styled-components";

export const AboutPageWrapper = styled.div`
    height: 85vh;
    margin: 0 7.5vw;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    @media (max-width:1200px)  { /* portrait e-readers (Nook/Kindle), smaller tablets @ 600 or @ 640 wide. */ 
        margin: 0 5vw;
        flex-direction: column;
        height: fit-content;
    }
    `

export const AboutPageTable = styled.table`
    margin: auto;
    height: 100%;
`

export const AboutPageContent = styled.div`
    margin: 0 5vw;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`

export const AboutPageText = styled.div`
    overflow-y: scroll;
    margin: auto;
`

export const AboutPageTitle = styled.h1`
    font-family: 'Lora', serif;
    color: rgb(12, 235, 179);
    margin-bottom: 3vh;
    margin-top: 0;
    letter-spacing: 3px;
    @media (max-width:481px)  { /* portrait e-readers (Nook/Kindle), smaller tablets @ 600 or @ 640 wide. */ 
        font-size: 10.5vw;
    }
`

export const AboutPageInformation = styled.p`
    font-size: 1.8em;
    display: flex;
    flex-direction: column;
    gap: 30px;
`

export const AboutPagePicture = styled.img`
    border-radius: 10px;
    @media (max-width:481px)  { /* portrait e-readers (Nook/Kindle), smaller tablets @ 600 or @ 640 wide. */ 
        display: none;
    }
`

export const ResumeButton = styled.a`
    margin: 0 0;
    margin-top: 3vh;
    width: max-content;
    cursor: pointer;
    border-radius: 4px;
    text-decoration: none;
    padding: 12px 18px;
    font-size: 12px;
    line-height: 19px;
    text-transform: uppercase;
    font-family: 'Montserrat', sans-serif; font-weight:400;
    letter-spacing: 3px;
    border:solid 2px #fff;
    background: transparent;
    color: #fff !important;
    -webkit-transition: all .4s ease-in-out;
       -moz-transition: all .4s ease-in-out;
        -ms-transition: all .4s ease-in-out;
         -o-transition: all .4s ease-in-out;
            transition: all .4s ease-in-out;

    &:hover{
        border:solid 2px #fff;
        background: #fff;
        color: #1f1f1f !important;
        -webkit-transition: all .4s ease-in-out;
       -moz-transition: all .4s ease-in-out;
        -ms-transition: all .4s ease-in-out;
         -o-transition: all .4s ease-in-out;
            transition: all .4s ease-in-out;
    }
`

export const SkillsSection = styled.div`
    padding: 8vh 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    @media (max-width:481px)  { /* portrait e-readers (Nook/Kindle), smaller tablets @ 600 or @ 640 wide. */ 
        padding: 3vh 6vw;
    }
`

export const SkillsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    @media (max-width:481px)  { /* portrait e-readers (Nook/Kindle), smaller tablets @ 600 or @ 640 wide. */ 
        display: grid;
        grid-template-columns: repeat(1, 1fr);
    }
`

export const ImportantWord = styled.span`
    color: rgb(12, 235, 179);
    text-transform: capitalize;
`

export const InfoStrip = styled.div`
    height: 65vh;
    width: 350px;
    margin-top: 10vh;
    padding: 20px;
    background-color: #121111;
    border-radius: 20px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media (max-width:1200px)  { /* portrait e-readers (Nook/Kindle), smaller tablets @ 600 or @ 640 wide. */ 
        margin: 5vh 5vw;
        width: calc(100% - 10vw);
        padding: 0;
    }
`

export const InfoStripImage = styled.img`
    border-radius: 20px;
    width: 300px;
`

export const GreenDot = styled.span`
    color: #2bb42b;
    font-size: 1.5em;
`

export const InfoStripText = styled.div`
    color: white;
    font-size: 1em;
    margin-top: 10px;
`

export const SocialLink = styled.a`
    height: 40px;
    width: 40px;
    overflow: hidden;
    background-color: #1E1F26;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        width: 30px;
        height: 30px;
        object-fit: cover;
        filter: brightness(0) invert(1);
    }
`

export const SocialLinkContainer = styled.div`
    display: flex;
    gap: 10px;
    margin-top: 10px;
`

export const ScrollableAboutPageSection = styled.div`
    height: 65vh;
    width: min(1170px, calc(85vw - 430px));
    margin-top: 10vh;
    padding: 20px;
    border-radius: 20px 20px 0 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;

    @media (max-width:1200px)  { /* portrait e-readers (Nook/Kindle), smaller tablets @ 600 or @ 640 wide. */ 
        margin: 0 5vw;
        width: calc(100% - 10vw);
        padding: 0;
        height: fit-content;
    }
`

export const AboutTitle = styled.h1`
     font-size: 2.5em;
`

export const TabWrapper = styled.img`
    height: 40px;
    width: 40px;
`

export const TabHR = styled.hr`
    width: 100%;
    border: none;
    border-top: 1px solid #ccc;
    margin: 20px 0;
`

export var AboutContentWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    gap: 20px;
    padding: 20px;
    background-color: #121111;
    border-radius: 20px;

    @media (max-width:1200px)  { /* portrait e-readers (Nook/Kindle), smaller tablets @ 600 or @ 640 wide. */ 
        flex-direction: column;
    }
`

export const JobImage = styled.img`
    width: 100px;
    border-radius: 20px;
`

export const VerticalLine = styled.div`
  width: 1px; /* Adjust thickness */
  height: 70%; /* Adjust height */
  background-color: rgb(12, 235, 179); /* Set color */
`

export const HorizontalLine = styled.div`
  height: 1px; /* Adjust thickness */
  width: 70%; /* Adjust height */
  background-color: rgb(12, 235, 179); /* Set color */
`


export const JobTitle = styled.h2`
    font-size: 1.5em;
    margin: 0;
`

export const HorizontalContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    @media (max-width:1200px)  { /* portrait e-readers (Nook/Kindle), smaller tablets @ 600 or @ 640 wide. */ 
        flex-direction: column;
    }
`

export const VerticalSpacer = styled.div`
    height: 30px; /* Adjust height as needed */
`

export var JobDescription = styled.p`
    font-size: 0.75em;
    margin: 0;
`

export const TechnologyIcon = styled.img`
    width: 50px;
    border-radius: 30px;
`

export const RelImagesContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 20px;

    @media (max-width:1200px)  { /* portrait e-readers (Nook/Kindle), smaller tablets @ 600 or @ 640 wide. */ 
        flex-direction: column;
    }
`

export const PorjectDescriptionPoint = styled.li`
    margin-bottom: 20px;

    &::marker {
        color: rgb(12, 235, 179);
    }
`

export const SkillImage = styled.img`
    height: 50px;
    filter: brightness(0) invert(1);
    border-radius: 10px;
`

export const InfoLabel = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    padding: 20px;
    width: 33%;
    @media (max-width:1200px)  { /* portrait e-readers (Nook/Kindle), smaller tablets @ 600 or @ 640 wide. */ 
        width: 100% ;
        padding: 20px 0;
    }
`